import { gql, useLazyQuery } from '@apollo/client'

const GET_INDICATIONS_QUERY = gql`
  query getIndicationsHomeRequest(
    $getIndicationRequest: GetIndicationRequest!
  ) {
    getIndicationsFinancingHome(getIndicationRequest: $getIndicationRequest) {
      success
      result {
        indications {
          customerid
          opportunityid
          status
          name
          cpf
          stepName
          substepName
          creationdate
          lastUpdateType
          lastUpdateTitle
          lastUpdateDescription
          lastUpdateDate
          itauApiStatus
          financingValue
          confirmedValue
          itauLogoUrl
        }
        page
        perPage
        total
      }
      message
    }
  }
`

export const useGetIndicationsHomeFin = ({ onError }) => {
  const [query, { loading }] = useLazyQuery(GET_INDICATIONS_QUERY, {
    onError,
  })

  const getIndicationsRequest = async input => {
    const response = await query({
      variables: {
        getIndicationRequest: input,
      },
    })

    return (
      response.data?.getIndicationsFinancingHome?.result ??
      response.data?.getIndicationsFinancingHome?.message ??
      []
    )
  }
  return { getIndicationsRequest, loading }
}
